import {
  OnsiteCampaignStatus,
  SendEmailMessage,
  Trigger,
  WebsiteContentMessage,
} from 'sections/onsite-campaigns/types';
import { CampaignInfo, FlagService, IsInFlowService } from './types';
import { TestModeStrategy } from './ValidationStrategies/TestModeStrategy';
import { ValidationStrategy } from './ValidationStrategies/ValidationStrategy';
import { SaveStrategy } from './ValidationStrategies/SaveStrategy';
import { CampaignEditorState } from '../../contexts/CampaignEditorState';
import { StateToWorkflowMapper } from './Mappers/StateToWorkflowMapper';
import { SplitTestsState } from '../../tabs/CampaignWorkflowTab/state/SplitTests/SplitTestsState';

export class Workflow {
  private constructor(
    private inFlowService: IsInFlowService,
    private flagService: FlagService,
    private campaignInfo: CampaignInfo,
    private trigger: Trigger,
    private onsiteMessages: WebsiteContentMessage[],
    private offsiteMessages: SendEmailMessage[],
    private splitTests: SplitTestsState,
    private branchNames: string[],
  ) {}

  public static createFromState(inFlowService: IsInFlowService, flagService: FlagService, state: CampaignEditorState) {
    const workflow = StateToWorkflowMapper.map(state);

    return new Workflow(
      inFlowService,
      flagService,
      workflow.campaignInfo,
      workflow.trigger,
      workflow.onsiteMessages,
      workflow.offsiteMessages,
      workflow.splitTests,
      workflow.branchNames,
    );
  }

  public moveToStatus(status: OnsiteCampaignStatus) {
    const strategies: { [key in OnsiteCampaignStatus]: ValidationStrategy } = {
      [OnsiteCampaignStatus.TEST]: new TestModeStrategy(
        this.inFlowService,
        this.flagService,
        this.campaignInfo,
        this.trigger,
        this.onsiteMessages,
        this.offsiteMessages,
        this.splitTests,
        this.branchNames,
      ),
      [OnsiteCampaignStatus.DRAFT]: undefined,
      [OnsiteCampaignStatus.LIVE]: undefined,
    };

    return strategies[status]?.validate();
  }

  public saveWorkflow() {
    return new SaveStrategy(this.campaignInfo, this.onsiteMessages).validate();
  }
}
